import Axios from "axios";
import { API_URL } from "../../../DesktopApp";
import React from "react";

const getCandidates = async (LIMIT, page) => {
  console.log(LIMIT,page)
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getAllCandidates`,
      { limit: LIMIT, page: page }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getTotalCandidatesCount = async () =>{
  try{
      const responseCount = await Axios.post(`${API_URL}/desktop/candidates/getAllCandidateCount`);
      return responseCount.data[0].canidatecount;
  }catch(err){
      return err;
  }
}

const getExportLeads = async () => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getAllExportCandidate`
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getExportSearchResult = async (
  data,
  createdtfrom,
  createdtto,
  followupdtfrom,
  followupdtto
) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/search/getAllExportSearchResult`,
      {
        source: data.get("source"),
        service_type: data.get("service_type"),
        pname: data.get("pname"),
        country: data.get("country"),
        state: data.get("state"),
        city: data.get("city"),
        locality: data.get("locality"),
        ptype: data.get("ptype"),
        pcategory: data.get("pcategory"),
        pconfiguration: data.get("configuration"),
        status: data.get("status"),
        anytext: data.get("anytext"),
        createdtfrom: createdtfrom,
        createdtto: createdtto,
        followupdtfrom: followupdtfrom,
        followupdtto: followupdtto,
        sales_manager: data.get("sales_manager"),
        tele_caller: data.get("tele_caller"),
        team_leader: data.get("team_leader"),
        branch_admin: data.get("branch_admin"),
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getSearchResult = async (
  LIMIT,
  page,
  data,
  createdtfrom,
  createdtto,
  followupdtfrom,
  followupdtto
) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/search/getCandidatesSearchResult`,
      {
        limit: LIMIT,
        page: page,
        c_source: data.get("candidate_source"),
        c_position: data.get("candidate_position"),
        c_status: data.get("candidate_status"),
        country: data.get("country"),
        state: data.get("state"),
        city: data.get("city"),
        locality: data.get("locality"),
        createdtfrom: createdtfrom,
        createdtto: createdtto,
        followupdtfrom: followupdtfrom,
        followupdtto: followupdtto,
        anytext: data.get("anytext"),
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getSearchResultCount = async (
  data,
  createdtfrom,
  createdtto,
  followupdtfrom,
  followupdtto
) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/getSearchResultCount`,
      {
        c_source: data.get("candidate_source"),
        c_position: data.get("candidate_position"),
        c_status: data.get("candidate_status"),
        country: data.get("country"),
        state: data.get("state"),
        city: data.get("city"),
        locality: data.get("locality"),
        createdtfrom: createdtfrom,
        createdtto: createdtto,
        followupdtfrom: followupdtfrom,
        followupdtto: followupdtto,
        anytext: data.get("anytext"),
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const unSetLead = async (candidate_id) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/candidates/deletecandidate`,
      {
        cid: candidate_id,
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

function groupBy(objectArray, property) {
  return objectArray.reduce((acc, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

const getDropdown = async () => {
  try {
    const source = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidateSource`
    );
    const position = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidatePosition`
    );
    const configuration = await Axios.post(
      `${API_URL}/desktop/searchdropdown/getConfiguration`
    );
    const status = await Axios.post(
      `${API_URL}/desktop/candidates/getCandidateStatus`
    );
    const usersList = await Axios.post(`${API_URL}/users/getUserList`);
    const locality = await Axios.post(
      `${API_URL}/desktop/searchdropdown/getLocality`
    );
    const users =
      usersList.data !== "No Data Found"
        ? groupBy(
            usersList.data.map((users) => ({
              label: users.username,
              value: users.u_id,
              urole: users.urole,
            })),
            "urole"
          )
        : [];
    return { source, position, configuration, status, users, locality };
  } catch (err) {
    return err;
  }
};

const setClick = async (cid) => {
  try {
    const response = await Axios.post(`${API_URL}/leads/setclick`, {
      cid: cid,
    });
    return response;
  } catch (err) {
    return err;
  }
};

export {
  getCandidates,
  getExportLeads,
  getExportSearchResult,
  unSetLead,
  getSearchResult,
  getSearchResultCount,
  getDropdown,
  setClick,
  getTotalCandidatesCount,
};
